<template>
  <button @click="onClick" class="mt-4 cta-button">
    <slot />
  </button>
</template>

<script>
  import { trackClick } from '@/utils/lpTracker';

  export default {
    name: "CtaButton",

    props: {
      // id de uma seção da própria página: o botão rola até ela em vez de disparar o CTA da página.
      secao: {
        type: String,
        default: null,
      },
    },

    methods: {
      onClick(event) {
        if (this.secao) {
          this.rolarAteSecao();
        } else {
          this.$root.$emit("ctaButtonClick");
        }
        this.$emit("click", event);

        const label = this.$slots.default?.[0]?.text?.trim() || 'CTA';
        trackClick(`Hero CTA - ${label}`);

        // const urlParams = new URLSearchParams(window.location.search);

        // this.$router.push({
        //   path: 'whatsapp',
        //   query: { ad: urlParams.get('ad') },
        // });
      },

      // Mesmo desconto do cabeçalho fixo usado no menu do BaseContainer.
      rolarAteSecao() {
        const el = document.getElementById(this.secao);
        if (!el) return;
        const top = el.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top, behavior: 'smooth' });
      },
    },
  };
</script>

<style scoped lang="scss">
  .cta-button {
    width: 285px;
    height: 63px;
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.3);
    background: linear-gradient(90deg, #23cf65 0%, #1a8f47 100%);
    color: #ffffff;
    font-size: 20px;
    font-style: normal;
    /* font-weight: 500; */
    line-height: 32px;
    @media (max-width: 780px) {
      width: 220px;
      font-size: 16px;
    }
  }
</style>
